// extracted by mini-css-extract-plugin
module.exports = {"BundleSectionWrapper":"StaticBundle_BundleSectionWrapper__Hf70j","fadeInOpacity":"StaticBundle_fadeInOpacity__Asi84"};